import { render, staticRenderFns } from "./GenreDetails.vue?vue&type=template&id=0ff46ee4&scoped=true"
import script from "./GenreDetails.vue?vue&type=script&lang=js"
export * from "./GenreDetails.vue?vue&type=script&lang=js"
import style0 from "./GenreDetails.vue?vue&type=style&index=0&id=0ff46ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff46ee4",
  null
  
)

export default component.exports